import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Text } from 'v3/components';
import * as S from '../styles';

export default function AnnulAdjustment({
  item,
  elapsedText,
  value, 
  onChange,
  loading,
  errors = {},    
  submitError = '',
}) {
  const descErr = errors.description;

  return (
    <div
      style={{
        ...S.formWrap,
        background: '#fff',
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        padding: 16,
      }}
    >
      <Row className="align-items-center mb-3">
        <Col>
          <Text type="header" color="dark">Anulação de pendência:</Text>
        </Col>
        <Col className="text-right">
          <Text type="label" color="dark" weight={600}>
            {item?.id} - {item?.reason}
          </Text>
        </Col>
      </Row>

      <div className="mb-3">
        <Text type="body" color="dark">Tempo decorrido: {elapsedText || '-'}</Text>
      </div>

      {submitError ? (
        <div className="alert alert-danger py-2 px-3 mb-3">
          {submitError}
        </div>
      ) : null}

      <Form.Group className="mb-2" controlId="annulResolution">
        <Form.Label className="d-flex justify-content-between align-items-center">
          <span>
            <Text type="label" color="dark" weight={600}>
              Motivo da anulação <span style={{ color: '#dc2626' }}>*</span>
            </Text>
          </span>
        </Form.Label>

        <Form.Control
          as="textarea"
          rows={6}
          value={value}
          onChange={(e) => onChange(e.target.value?.slice())}
          placeholder="Descreva o motivo da anulação…"
          style={{ resize: 'vertical', borderColor: '#e5e7eb', background: '#ffffff' }}
          isInvalid={!!descErr}
          disabled={!!loading}
        />
        <Form.Control.Feedback type="invalid">
          {descErr}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
}
